import Advantages from "../components/common/advantages/index.vue";
import Advertisement from "../components/common/advertisement/index.vue";
import HowItWorks from "../components/common/howItWorks/index.vue";
import EventCalendar from "../components/common/EventCalendar/index.vue";
import BecomeAProvider from "../components/home/BecomeAProvider/index.vue";
import Reviews from "../components/home/Reviews/index.vue";
import Hero from "../components/home/Hero/index.vue";
import Categories from "../components/home/Categories/index.vue";
import DotCarousel from "../components/common/DotCarousel/index.vue";

window.app.component("advantages", Advantages);
window.app.component("advertisement", Advertisement);
window.app.component("hero", Hero);
window.app.component("how-it-works", HowItWorks);
window.app.component("event-calendar", EventCalendar);
window.app.component("become-a-provider", BecomeAProvider);
window.app.component("reviews", Reviews);
window.app.component("categories", Categories);
window.app.component("dot-carousel", DotCarousel);